var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import './HeaderApp.scss';
var HeaderApp = function (_a) {
    var party = _a.party;
    return (_jsx("div", __assign({ className: "component__header-app" }, { children: party.name }), void 0));
};
export default HeaderApp;
